<div *ngIf="(vm$ | async) as vm;">
  <mode-paginator
    *ngIf="vm.pageCount > 1"
    [class]="{ paginator: true, settings: paginationStyle === 'button' }"
    [currentPage]="vm.currentPage"
    [numberOfPages]="vm.pageCount"
    (pageChangeEvent)="handleChangeCurrentPage($event)"
  ></mode-paginator>
  <span *ngIf="vm.itemTotal > 1" class="paginator-page-range">
    showing {{vm.pageItemRangeStart}}-{{vm.pageItemRangeEnd}} of {{vm.itemTotal}}
  </span>
</div>
